import { FieldType } from "@/data/forms/types";
import { fieldComponents } from "@/utils/Form";
import classNames from "classnames";
import {
  FieldErrors,
  FieldValues,
  UseFormClearErrors,
  UseFormRegister,
  UseFormSetError,
  UseFormSetValue,
  UseFormTrigger,
  UseFormUnregister,
  UseFormWatch,
} from "react-hook-form";

export const FormField = <T extends FieldValues>({
  field,
  t,
  watch,
  register,
  unregister,
  trigger,
  setValue,
  errors,
  setError,
  clearErrors,
  touchedFields,
  isSubmitted,
  values,
  dynamicValidation,
  nextStepTriggerCount,
}: {
  field: FieldType;
  t: Record<string, string>;
  watch: UseFormWatch<T>;
  register: UseFormRegister<T>;
  unregister: UseFormUnregister<T>;
  trigger: UseFormTrigger<T>;
  setValue: UseFormSetValue<T>;
  errors: FieldErrors<T>;
  setError: UseFormSetError<T>;
  clearErrors: UseFormClearErrors<T>;
  touchedFields: Partial<Record<keyof T, boolean>>;
  isSubmitted: boolean;
  values: any;
  dynamicValidation?: Record<string, unknown>;
  nextStepTriggerCount?: number;
}) => {
  const FieldComponent =
    fieldComponents[field.component] || (() => <p>Tipo de campo no soportado</p>);

  const formFieldClassnames = classNames(`u-grid-col-${field.uniqueRow ? 12 : field.cols || 12}`, {
    "u-grid": field.uniqueRow,
    [`Step__field--${field.name}`]: field.name,
    [`Step__field--${field.name}--${values[field.name] ? "checked" : "unchecked"}`]:
      field.component === "Check" && field.name.includes("Incorrect"),
  });

  return (
    <div className={formFieldClassnames}>
      <FieldComponent
        className={field.uniqueRow && field.cols ? `u-grid-col-${field.cols}` : ""}
        t={t}
        field={field}
        register={register}
        unregister={unregister}
        touchedFields={touchedFields}
        isSubmitted={isSubmitted}
        watch={watch}
        trigger={trigger}
        setValue={setValue}
        values={values}
        errors={errors}
        setError={setError}
        clearErrors={clearErrors}
        component={field.component}
        dynamicValidation={dynamicValidation}
        nextStepTriggerCount={nextStepTriggerCount}
      />
    </div>
  );
};
